<div class="yes-no-rating">
  <label
    [attr.for]="field().key"
    class="mb-0 d-block fw-bold widget-label"
    >{{ field().settings?.label }}
    @if (field().settings?.required) {
      <span class="text-primary ms-1">*</span>
    }
  </label>

  <div class="row mt-2">
    <div
      class="yes-no-rating-item d-flex align-items-center col col-6 col-md-2"
    >
      <input
        [value]="1"
        class="radio-input me-1"
        [id]="field().key + '-yes'"
        [name]="field().key"
        type="radio"
        [class.disabled-input]="!editable"
        [checked]="selectedValue === 1"
        (change)="onChangeSelection($event)"
      />

      <div class="d-flex align-items-center">
        <label
          class="radio-info truncate-line-1"
          [for]="field().key + '-yes'"
          [class.disabled-action]="!editable"
        >
          <span
            class="radio-text font-size-base"
            translate
          >
            JuryForm.YesNoRating.Yes
          </span>
        </label>
      </div>
    </div>

    <div
      class="yes-no-rating-item d-flex align-items-center col col-6 col-md-2"
    >
      <input
        [value]="'0'"
        class="radio-input me-1"
        [id]="field().key + '-no'"
        [name]="field().key"
        type="radio"
        [class.disabled-input]="!editable"
        [checked]="selectedValue === 0"
        (change)="onChangeSelection($event)"
      />

      <div class="d-flex align-items-center">
        <label
          class="radio-info truncate-line-1"
          [for]="field().key + '-no'"
          [class.disabled-action]="!editable"
        >
          <span
            class="radio-text font-size-base"
            translate
          >
            JuryForm.YesNoRating.No
          </span>
        </label>
      </div>
    </div>
  </div>
</div>
